import React from 'react';
import { Sparkles, Heart, Leaf, Star, ArrowRight, Gift, Check, MapPin, Phone, Mail, Clock } from 'lucide-react';

const HomePage = ({
  eclipseaLogo,
  scrollToServices,
  handleGiftCardClick,
  onAboutClick
}) => {
  return (
    <>
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Fond animé */}
        <div className="absolute inset-0 bg-gradient-to-br from-purple-100 via-pink-50 to-amber-50">
          <div className="absolute inset-0 opacity-30">
            <div className="absolute top-20 left-10 w-72 h-72 bg-purple-300 rounded-full mix-blend-multiply filter blur-3xl animate-blob"></div>
            <div className="absolute top-40 right-10 w-72 h-72 bg-pink-300 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-2000"></div>
            <div className="absolute bottom-20 left-1/3 w-72 h-72 bg-amber-300 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-4000"></div>
          </div>
        </div>

        <div className="relative z-10 container mx-auto px-4 py-20 text-center">
          <div className="flex items-center justify-center gap-8 mb-12 flex-wrap">
            {/* Logo et titre principal
            <button className="flex items-center gap-4" onClick={() => window.location.href = 'https://www.eclipsea.fr/'}>
              <img
                src={eclipseaLogo}
                alt="Eclipsea Spa Privatif"
                className="h-24 md:h-32 drop-shadow-2xl"
              />
            </button>
            
            <div className="w-px h-20 bg-gradient-to-b from-transparent via-purple-400 to-transparent hidden md:block"></div> */}
            <div>
              <h1 className="text-5xl md:text-7xl font-light text-purple-900 mb-2 tracking-wide">
                Alaia Cristal
              </h1>
              <p className="text-2xl md:text-3xl text-purple-700 font-light">
                Bien-être
              </p>
            </div>
          </div>

          <p className="text-xl md:text-2xl text-gray-700 mb-8 max-w-3xl mx-auto font-light leading-relaxed">
            Massages bien-être et soins au {' '}
            <a
              href="https://www.eclipsea.fr"
              target="_blank"
              rel="noopener noreferrer"
              className="text-purple-600 font-medium hover:text-purple-800 transition-colors underline decoration-purple-300 hover:decoration-purple-600"
            >
              Spa Eclipsea de Bessines (79)
            </a>
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <button
              onClick={scrollToServices}
              className="group bg-gradient-to-r from-purple-600 to-pink-600 text-white px-10 py-5 rounded-full text-lg font-medium shadow-2xl hover:shadow-purple-500/50 transition-all duration-300 transform hover:scale-105 flex items-center gap-3"
            >
              Découvrir nos soins
              <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform" />
            </button>

            <button
              onClick={onAboutClick}
              className="group bg-white/90 backdrop-blur-sm text-purple-700 px-10 py-5 rounded-full text-lg font-medium shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105 flex items-center gap-3 border-2 border-purple-200"
            >
              <Sparkles className="w-5 h-5" />
              Notre univers
            </button>
          </div>
        </div>
      </section>

      {/* Section détaillée Cartes Cadeaux - AMÉLIORÉE */}
      <section className="py-20 bg-gradient-to-br from-amber-50 via-purple-50 to-pink-50">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto bg-white rounded-3xl shadow-2xl overflow-hidden border border-amber-100">
            <div className="grid grid-cols-1 md:grid-cols-2">
              {/* Partie gauche - Informations */}
              <div className="p-8 md:p-12">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-12 h-12 bg-gradient-to-br from-amber-500 to-amber-600 rounded-xl flex items-center justify-center text-white shadow-lg">
                    <Gift className="w-6 h-6" />
                  </div>
                  <h2 className="text-3xl font-light text-purple-900">
                    Offrez du Bien-être
                  </h2>
                </div>

                <p className="text-gray-600 mb-6 leading-relaxed">
                  Faites plaisir à vos proches avec nos cartes cadeaux personnalisables.
                  Un cadeau parfait pour toutes les occasions : anniversaire, fête des mères,
                  Saint-Valentin ou simplement pour faire plaisir.
                </p>

                <div className="space-y-4 mb-8">
                  <div className="flex items-start gap-3">
                    <Check className="w-6 h-6 text-amber-600 flex-shrink-0 mt-0.5" />
                    <div>
                      <p className="font-semibold text-purple-900">Choix de montants</p>
                      <p className="text-sm text-gray-600">De 50€ à 200€ selon votre budget</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <Check className="w-6 h-6 text-amber-600 flex-shrink-0 mt-0.5" />
                    <div>
                      <p className="font-semibold text-purple-900">Validité 6 mois</p>
                      <p className="text-sm text-gray-600">Utilisable en une ou plusieurs fois</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <Check className="w-6 h-6 text-amber-600 flex-shrink-0 mt-0.5" />
                    <div>
                      <p className="font-semibold text-purple-900">Message personnalisé</p>
                      <p className="text-sm text-gray-600">Ajoutez un mot doux à votre cadeau</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <Check className="w-6 h-6 text-amber-600 flex-shrink-0 mt-0.5" />
                    <div>
                      <p className="font-semibold text-purple-900">Envoi immédiat</p>
                      <p className="text-sm text-gray-600">Reçu par email en quelques minutes</p>
                    </div>
                  </div>
                </div>

                <button
                  onClick={handleGiftCardClick}
                  className="w-full bg-gradient-to-r from-amber-500 via-amber-600 to-amber-700 text-white px-8 py-4 rounded-xl font-medium hover:shadow-2xl hover:shadow-amber-500/50 transition-all duration-300 transform hover:scale-[1.02] flex items-center justify-center gap-2 shadow-xl"
                >
                  <Gift className="w-5 h-5" />
                  Commander une carte cadeau
                </button>
              </div>

              {/* Partie droite - Visuel carte cadeau AMÉLIORÉ */}
              <div className="bg-gradient-to-br from-amber-100 via-purple-100 to-pink-100 p-8 md:p-12 flex items-center justify-center relative overflow-hidden">
                {/* Motifs décoratifs */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-white/20 rounded-full -translate-y-1/2 translate-x-1/2"></div>
                <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/20 rounded-full translate-y-1/2 -translate-x-1/2"></div>

                <div className="relative w-full max-w-sm z-10">
                  {/* Carte principale */}
                  <div className="bg-gradient-to-br from-amber-500 via-amber-600 to-purple-700 rounded-3xl p-8 text-white shadow-2xl transform hover:rotate-2 transition-all duration-300 hover:shadow-amber-500/50">
                    <div className="text-center">
                      <div className="relative inline-block mb-4">
                        <Gift className="w-16 h-16 mx-auto opacity-90" />
                        <Sparkles className="w-6 h-6 absolute -top-2 -right-2 text-amber-200 animate-pulse" />
                      </div>

                      <h3 className="text-2xl font-bold mb-2">Carte Cadeau</h3>
                      <p className="text-lg opacity-90 mb-6">Alaia Cristal Bien-être</p>

                      <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-6 mb-6 border border-white/30">
                        <p className="text-4xl font-bold mb-2">50€ - 200€</p>
                        <p className="text-sm opacity-75">Au choix</p>
                      </div>

                      <div className="text-xs opacity-90 space-y-1 bg-white/10 rounded-xl p-4 backdrop-blur-sm">
                        <p className="flex items-center justify-center gap-2">
                          <Check className="w-4 h-4" /> Valable 6 mois
                        </p>
                        <p className="flex items-center justify-center gap-2">
                          <Check className="w-4 h-4" /> Tous les soins
                        </p>
                        <p className="flex items-center justify-center gap-2">
                          <Check className="w-4 h-4" /> Envoi par email
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Carte d'arrière-plan (effet de profondeur) */}
                  <div className="absolute -bottom-4 -right-4 w-full h-full bg-gradient-to-br from-amber-400 to-purple-500 rounded-3xl -z-10 opacity-60"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-light text-purple-900 mb-4">
              Pourquoi choisir Alaia Cristal ?
            </h2>
            <div className="flex items-center justify-center gap-4 mt-6">
              <div className="h-px w-24 bg-gradient-to-r from-transparent via-amber-400 to-transparent"></div>
              <Star className="w-6 h-6 text-amber-500" />
              <div className="h-px w-24 bg-gradient-to-r from-transparent via-amber-400 to-transparent"></div>
            </div>
          </div>

          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Expertise */}
            <div className="group bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-purple-100">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-purple-700 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Star className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-medium text-purple-900 mb-3">36 ans d'expertise</h3>
              <p className="text-gray-600 leading-relaxed">
                Une maîtrise parfaite des techniques de massage et une approche intuitive du bien-être
              </p>
            </div>

            {/* Cadre exceptionnel */}
            <div className="group bg-gradient-to-br from-amber-50 to-purple-50 rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-amber-100">
              <div className="w-16 h-16 bg-gradient-to-br from-amber-500 to-amber-700 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Sparkles className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-medium text-purple-900 mb-3">Cadre d'exception</h3>
              <p className="text-gray-600 leading-relaxed">
                Au cœur du Spa Eclipsea, un lieu magique pensé pour la détente et la reconnexion à soi
              </p>
            </div>

            {/* Personnalisation */}
            <div className="group bg-gradient-to-br from-pink-50 to-purple-50 rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-pink-100">
              <div className="w-16 h-16 bg-gradient-to-br from-pink-500 to-pink-700 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Heart className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-medium text-purple-900 mb-3">Soins sur-mesure</h3>
              <p className="text-gray-600 leading-relaxed">
                Chaque soin est adapté à vos besoins pour une expérience unique et personnalisée
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-br from-purple-50 via-pink-50 to-amber-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-purple-100">
              <div className="bg-gradient-to-r from-purple-600 to-pink-600 p-8 text-white text-center">
                <h2 className="text-3xl font-light mb-2">Besoin d'informations ?</h2>
                <p className="text-purple-100">Nous sommes à votre écoute</p>
              </div>

              <div className="p-8 md:p-12">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  {/* Coordonnées */}
                  <div className="space-y-6">
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center flex-shrink-0">
                        <MapPin className="w-6 h-6 text-purple-600" />
                      </div>
                      <div>
                        <h3 className="font-semibold text-purple-900 mb-1">Adresse</h3>
                        <p className="text-gray-600">Spa Eclipsea<br />Bessines</p>
                      </div>
                    </div>

                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center flex-shrink-0">
                        <Phone className="w-6 h-6 text-amber-600" />
                      </div>
                      <div>
                        <h3 className="font-semibold text-purple-900 mb-1">Téléphone</h3>
                        <a href="tel:0647139304" className="text-purple-600 hover:text-purple-800 transition-colors">
                          06.47.13.93.04
                        </a>
                      </div>
                    </div>

                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 bg-pink-100 rounded-xl flex items-center justify-center flex-shrink-0">
                        <Mail className="w-6 h-6 text-pink-600" />
                      </div>
                      <div>
                        <h3 className="font-semibold text-purple-900 mb-1">Email</h3>
                        <a href="mailto:alaia.cristalbienetre@gmail.com" className="text-purple-600 hover:text-purple-800 transition-colors break-all">
                          alaia.cristalbienetre@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>

                  {/* Horaires */}
                  <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-6">
                    <div className="flex items-center gap-3 mb-6">
                      <Clock className="w-6 h-6 text-purple-600" />
                      <h3 className="font-semibold text-purple-900">Horaires d'ouverture</h3>
                    </div>
                    <div className="space-y-3 text-gray-700">
                      <div className="flex justify-between">
                        <span className="font-medium">Mardi</span>
                        <span>14h - 20h</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="font-medium">Mercredi</span>
                        <span>11h - 20h</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="font-medium">Jeudi</span>
                        <span>11h - 20h</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="font-medium">Vendredi</span>
                        <span>11h - 20h</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="font-medium">Samedi</span>
                        <span>10h - 18h</span>
                      </div>
                      <div className="pt-3 border-t border-purple-200 text-sm text-gray-500">
                        Lundi et Dimanche : Fermé
                      </div>
                    </div>
                  </div>
                </div>

                {/* CTA Réserver */}
                <div className="mt-8 text-center">
                  <button
                    onClick={scrollToServices}
                    className="bg-gradient-to-r from-purple-600 to-pink-600 text-white px-10 py-4 rounded-full font-medium shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
                  >
                    Réserver mon soin
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomePage;